import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class NodeUserPresenter extends EntityPresenter {
  static urn = 'node-user'

  static navOptions(key ='node-user') {
    const routes = {
      "node-user": {
        icon: 'assignment_ind',
        pageRoutes: ['node-user'],
      }
    }
    return routes[key]
  }
}

bindPresenterMethods(NodeUserPresenter)
